import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./routes";
import { useSelector } from "react-redux";
import { connectSocket, disconnectSocket } from "./socket/socket";

const App = () => {
  // Get user ID from Redux
  const admin = useSelector((state) => state.adminProfile); // Adjust state path as needed

  useEffect(() => {
    if (admin?.AdminProfile?._id) {
      connectSocket(admin.AdminProfile._id); // Pass the user ID to the socket connection
    }

    return () => {
      disconnectSocket(); // Disconnect when component unmounts
    };
  }, [admin]);
  return <RouterProvider router={router} />;
};

export default App;
